import { render, staticRenderFns } from "./DesiredDelivery.vue?vue&type=template&id=049eee96&"
import script from "./DesiredDelivery.vue?vue&type=script&lang=js&"
export * from "./DesiredDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports